import { render } from "./AnnouncementsLayout.vue?vue&type=template&id=7f21fdec"
import script from "./AnnouncementsLayout.vue?vue&type=script&lang=js"
export * from "./AnnouncementsLayout.vue?vue&type=script&lang=js"

import "./AnnouncementsLayout.vue?vue&type=style&index=0&id=7f21fdec&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__